import * as z from "zod";

export const getTemuIntegration = {
  name: "getTemuIntegration" as const,
  input: z.object({}),
  output: z.object({
    exists: z.boolean(),
    mallId: z.string().nullable(),
    mallType: z.number().nullable(),
    omsEnabled: z.boolean(),
    returnsEnabled: z.boolean(),
    isUsingRedoReturnLabels: z.boolean(),
  }),
};
